import { Component, Input, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { SafePipe } from '../pipes';

@Component({
	selector: 'app-infobox',
	templateUrl: './infobox.component.html',
	styleUrls: ['./infobox.component.scss'],
	imports: [MatIcon, SafePipe],
})
export class InfoboxComponent implements OnInit {
	constructor() {
		this.setIcon();
	}

	@Input() displayType: 'warning' | 'success' | 'danger' = 'warning';
	@Input() header!: string;
	@Input() body?: string;
	@Input() includeIcon = true;

	icon = 'sl-alert';

	ngOnInit(): void {
		this.setIcon();
	}

	setIcon(): void {
		if (this.displayType === 'warning') {
			this.icon = 'sl-alert';
		}
		if (this.displayType === 'success') {
			this.icon = 'sl-alert';
		}
		if (this.displayType === 'danger') {
			this.icon = 'sl-alert';
		}
	}
}
